import React, { Component } from 'react';
import {Form, Row, Col, Button} from 'react-bootstrap';
import DataDropdown from '../common_components/DataDropdown';
import {getAPI, postAPI} from '../common_components/common.js';
import '../FormPage.css'
const { Translate } = require('react-i18nify');

// The API reports failures as {success: false, error: {status, error, message, ...}},
// but getAPI()/postAPI() swallow network errors and resolve with undefined
function getErrorMessage(res, defaultMsg) {
	if(res == undefined || res['error'] == undefined)
		return defaultMsg;

	const error = res['error'];
	if(typeof error !== 'object')
		return error;

	return error['message'] ? error['message'] : defaultMsg;
}

export default class CC2Version extends Component {
	constructor(props) {
		super(props);

		this.state = {
			errors: {},
			versionsList: [],
			selectedVersion: '',
			bUpdating: false,
		};
		this.onVersionChanged = this.onVersionChanged.bind(this);
		this.onUpdateVersion = this.onUpdateVersion.bind(this);
	}

	componentDidMount() {
		getAPI("common/cc2x/versions").then(resVersions => {
			if(resVersions != undefined && resVersions['success']) {
				this.setState({
					versionsList: resVersions['data'],
				});
			} else {
				alert(getErrorMessage(resVersions, "Unable to load the list of CC2 versions."));
			}
		});
	}

	onVersionChanged(event) {
		this.setState({
			selectedVersion: event.target.value,
			errors: {},
		});
	}

	onUpdateVersion() {
		const version = this.state.selectedVersion;
		if(version == '') {
			const errMsg = "Please select a version.";
			this.setState({
				errors: {selectedVersion: errMsg},
			});
			alert(errMsg);
			return;
		}

		if(!window.confirm("Set the CC2 version to " + version + "?"))
			return;

		this.setState({bUpdating: true});
		postAPI("common/cc2x/versions/latest", {value: version}).then(resVersion => {
			this.setState({bUpdating: false});
			if(resVersion != undefined && resVersion['success']) {
				const messages = resVersion['data'];
				alert(messages != undefined && messages.length > 0
					? messages[0] : "Successfully updated to " + version + ".");
			} else {
				alert(getErrorMessage(resVersion, "Failed to update the CC2 version."));
			}
		});
	}

	render() {
		return(
			<Form className='form-page' horizontal style={{maxHeight: 'none'}}>
				<Row>
					<Col md={12}>
						<h4><Translate value='components.settings.CC2 Version' /></h4>
						<DataDropdown required
							label={<Translate value='components.settings.Version' />}
							name={'value'}
							data={this.state.versionsList}
							colValue={'value'}
							colText={'label'}
							value={this.state.selectedVersion}
							action={this.onVersionChanged}
							errMsg={this.state.errors.selectedVersion
								? this.state.errors.selectedVersion : ""}
						/>
					</Col>
				</Row>
				<Row>
					<Col md={12}>
						<Button bsSize='sm' bsStyle="primary"
							disabled={this.state.bUpdating}
							onClick={this.onUpdateVersion}
						>
							<Translate value='components.settings.Update Version' />
						</Button>
					</Col>
				</Row>
			</Form>
		);
	}
}
